import { API_AUTH } from "./common";

const DanhSachKiemKhoApi = {
  // list: ({
  //   tenKH,
  //   loaiKH,
  //   tinhtrangKH,
  //   trangthaiKH,
  //   nguonKH,
  //   pageIndex,
  //   pageSize,
  // }) =>
  //   API_AUTH.get(
  //     `quanlytaisan/kiem-kho?tenKH=${tenKH}&loaiKH=${loaiKH}&tinhtrangKH=${tinhtrangKH}&trangthaiKH=${trangthaiKH}&nguonKH=${nguonKH}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
  //     {}
  //   ),
  list: ({ makiemkho }) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-bien-ban-kiem-kho?makiemkho=${makiemkho}`,
      {}
    ),
  list1: ({ makiemkho, nguoikiemkho, tuNgay, denNgay }) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-bien-ban-kiem-kho-1?makiemkho=${makiemkho}&nguoikiemkho=${nguoikiemkho}&tuNgay=${tuNgay}&denNgay=${denNgay}`,
      {}
    ),
  phanquyenDsKiemKho: () =>
    API_AUTH.get(`quan-ly-tai-san/phan-quyen-danh-sach-bien-ban-kiem-kho`, {}),
  chiTietBienBanKiemKho: (bienbanId) =>
    API_AUTH.get(
      `quan-ly-tai-san/chi-tiet-bien-ban-kiem-kho?bienbanId=${bienbanId}`,
      {}
    ),
  getInDanhSachKiemKho: (makiemkho, nguoikiemkho, tuNgay, denNgay) =>
    API_AUTH.get(
      `quan-ly-tai-san/in-danh-sach-bien-ban-kiem-kho?makiemkho=${makiemkho}&nguoikiemkho=${nguoikiemkho}&tuNgay=${tuNgay}&denNgay=${denNgay}`,
      {}
    ),
  getInChiTietBienBan: (Id) =>
    API_AUTH.get(`quan-ly-tai-san/in-chi-tiet-bien-ban-kiem-kho?Id=${Id}`, {}),
};

export default DanhSachKiemKhoApi;
